import { Button, Tooltip } from '@usealloy/component-library';
import React from 'react';
import PropTypes from 'prop-types';
import MomentPropTypes from 'react-moment-proptypes';

import MessageExpirationBar from '~/dashboard/components/MessageExpirationBar';


const MessageShape = PropTypes.shape({
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  type: PropTypes.string.isRequired,
  expireIn: PropTypes.number.isRequired,
});

const MessagesPropTypes = {
  sidebarExpanded: PropTypes.bool.isRequired,
  messages: PropTypes.arrayOf(MessageShape).isRequired,
  displayedAt: MomentPropTypes.momentObj,
  deleteMessage: PropTypes.func.isRequired,
};

const MessagesDefaultProps = {
  displayedAt: null,
};

const Messages = ({
  sidebarExpanded, messages, displayedAt, deleteMessage,
}) => {
  const message = messages.length > 0 && messages[0];
  let expiration = null;
  if (message && message.expireIn && displayedAt) {
    expiration = displayedAt.clone();
    expiration.add(message.expireIn, 'milliseconds');
  }

  const getMessageIcon = type => {
    if (type === 'success') return <i className="fas fa-fw fa-lg fa-check-circle jade" />;
    if (type === 'error') {
      return (
        <span className="fa-fw fa-stack fa-xs">
          <i className="fas fa-stack-2x fa-triangle red" />
          <i className="fas fa-stack-1x fa-exclamation white" />
        </span>
      );
    }
    return null;
  };

  return (
    <ul
      id="spa-messages"
      className={`${!sidebarExpanded ? 'expanded' : ''} ${messages.length ? '' : 'empty'}`}
    >
      {message && (
        <>
          {expiration && (
            <MessageExpirationBar
              displayedAt={displayedAt}
              expiration={expiration}
              messageType={message.type}
            />
          )}

          <li className="message flex space">
            <span className="flex start h-space-8">
              {getMessageIcon(message.type)}
              <span>
                {message.text}
                {messages.length > 1 ? ` (and ${messages.length - 1} more)` : ''}
              </span>
            </span>

            {!expiration && (
              <Tooltip content="Dismiss" delayDuration={0}>
                <Button
                  id="close-message"
                  onClick={deleteMessage}
                >
                  <i className="fal fa-fw fa-lg fa-times" />
                </Button>
              </Tooltip>
            )}
          </li>
        </>
      )}
    </ul>
  );
};
Messages.propTypes = MessagesPropTypes;
Messages.defaultProps = MessagesDefaultProps;


export default Messages;
